import React from "react";
import ContentLoader from "react-content-loader";

const LoaderVisualisationAnnonce = (props) => {
  return (
    <ContentLoader
      viewBox="0 0 700 520"
      width="100%"
      height="auto"
      preserveAspectRatio="xMidYMid meet"
      backgroundColor="#f5f5f5"
      foregroundColor="#dbdbdb"
      {...props}
    >
      {/* Breadcrumb */}
      <rect x="20" y="18" rx="6" ry="6" width="420" height="14" />

      {/* Left: gallery (big) */}
      <rect x="20" y="52" rx="14" ry="14" width="440" height="260" />

      {/* Left: title/price/meta */}
      <rect x="20" y="330" rx="8" ry="8" width="360" height="18" />
      <rect x="20" y="360" rx="8" ry="8" width="180" height="16" />
      <rect x="20" y="388" rx="8" ry="8" width="260" height="14" />
      <rect x="20" y="412" rx="8" ry="8" width="220" height="14" />

      {/* Right card */}
      <rect x="480" y="52" rx="14" ry="14" width="200" height="260" />

      {/* Right card title */}
      <rect x="498" y="74" rx="8" ry="8" width="165" height="16" />

      {/* Right card rows */}
      <rect x="498" y="110" rx="6" ry="6" width="110" height="12" />
      <rect x="498" y="130" rx="6" ry="6" width="150" height="12" />

      <rect x="498" y="160" rx="6" ry="6" width="95" height="12" />
      <rect x="498" y="180" rx="6" ry="6" width="140" height="12" />

      <rect x="498" y="210" rx="6" ry="6" width="120" height="12" />
      <rect x="498" y="230" rx="6" ry="6" width="155" height="12" />

      {/* Back button */}
      <rect x="480" y="330" rx="12" ry="12" width="200" height="42" />
    </ContentLoader>
  );
};

export default LoaderVisualisationAnnonce;
